import Vue from 'vue'
import App from './App'
import router from './router/index.js'
import store from './store'
import axios from 'axios'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'element-ui/lib/theme-chalk/display.css'
// import perforemanceMonitor from './tools/performance'
Vue.use(ElementUI)
// import track from './tools/track'
// window.loadingCount = 0
Vue.prototype.$axios = axios
// window.forbidMaskTouch = function () {
//     window.setTimeout(() => {
//         const masks = ['mint-msgbox', 'mint-indicator-wrapper', 'mint-actionsheet-button']
//         masks.forEach((item) => {
//             const t = document.getElementsByClassName(item)[0]
//             if (t) {
//                 t.addEventListener('touchmove', (e) => {
//                     e.preventDefault()
//                 })
//             }
//         })
//     }, 0)
// }
// track.execute()
router.beforeEach((to, from, next) => {
    /* 路由发生变化修改页面title */
    if (to.meta.title) {
        document.title = to.meta.title
    }
    next()
})
/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    render: h => h(App)
})
// perforemanceMonitor.execute()



// WEBPACK FOOTER //
// ./src/client/main.js